<template>
    <v-container grid-list-xl>
        <v-layout my-6>
            <v-btn @click="$router.go(-1)" class="my-auto">
                <v-icon>navigate_before</v-icon>
                {{ $t('back') }}
            </v-btn>

            <v-flex ml-12 xs10>
                <div class="display-3 font-weight-thin">{{ $i18n.t('users') }}</div>
            </v-flex>

            <v-spacer/>

            <v-btn @click="createUser" class="my-auto mx-4" color="teal">
                {{ $t('addUser') }}
                <v-icon right>add</v-icon>
            </v-btn>
        </v-layout>

        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="getUsers"
                    :items-per-page="15"
                    :loading="isLoading"
                    :loading-text="$i18n.t('loading')"
                    :no-results-text="$t('noResults')"
                    :no-data-text="$t('noData')"
                    sort-by="lastAccess"
                    :sort-desc="true">

                    <template v-slot:item.lastAccess="{ item }">
                        {{ toDatetime(item.lastAccess) }}
                    </template>

                    <template v-slot:item.admin="{ item }">
                        <v-switch v-model="item.admin" @change="updateUser(item)"/>
                    </template>

                    <template v-slot:item.active="{ item }">
                        <v-switch v-model="item.active" @change="updateUser(item)"/>
                    </template>

                    <template v-slot:item.password="{ item }">
                        <v-icon @click="changePassword(item)">edit</v-icon>
                    </template>

                    <template v-slot:item.subjects="userItem">
						<v-overflow-btn
							:items="getSubjects"
                            v-model="getTeachingsByUser[userItem.item.id]"
                            item-value="id"
							multiple
							dense
							class="mt-3 mb-n3">

                            <template v-slot:selection="{ index }">
                                {{ index == getTeachingsByUser[userItem.item.id].length-1 ? index+1 + " " + (index == 0 ? $t('subjectSelected') : $t('subjectsSelected')) : "" }}
                            </template>

                            <template v-slot:item="subjectItem">
                                <v-checkbox
                                    v-model="subjectItem.attrs.inputValue"
                                    :label="subjectItem.item.name"
                                    @change="$store.dispatch('updateTeaching', {userId: userItem.item.id, subjectId: subjectItem.item.id, value: subjectItem.attrs.inputValue})"
                                    :disabled="isLoading"/>
                            </template>
                        </v-overflow-btn>
                            
                    </template>
                </v-data-table>
            </v-card-text>

            <v-dialog v-model="createUserDialog" max-width="1300px">
                <CreateUser/>
            </v-dialog>

            <v-dialog v-model="editPasswordDialog" max-width="800px">
                <EditPassword/>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import toDatetime from '@/components/dateParser';
import CreateUser from '@/components/User/CreateUser'
import EditPassword from '@/components/User/EditPassword'

export default {
    methods: {
        createUser(){
            this.$store.commit('newUser')
            this.$store.commit('setCreateUserDialog', true)
        },
        updateUser(user){
            this.$store.commit('setUser', user)
            this.$store.commit('resetUserValues')
            this.$store.dispatch('updateUser')
        },
        changePassword(user){
            this.$store.commit('setUser', user)
            this.$store.commit('resetUserValues')
            this.$store.commit('setEditPasswordDialog', true)
        },
    },

    created(){
        this.$store.dispatch('getUsers')
        this.$store.dispatch('getSubjects')
        this.$store.dispatch('getTeachingsByUser')
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getUsers',
			'getSubjects',
            'getTeachingsByUser',
            'getCreateUserDialog',
            'getEditPasswordDialog',
        ]),
        headers() { 
            return[
                { text: "ID", value: 'id', align: 'left', width: "10px"},
                { text: this.$t('name'), value: 'fullName', align: 'left' },
                { text: this.$t('email'), value: 'email', align: 'left' },
                { text: this.$t('lastAccess'), value: 'lastAccess', align: 'center'},
                { text: this.$t('admin'), value: 'admin', align: 'center', sortable: false, width: "10px"},
                { text: this.$t('active'), value: 'active', align: 'center', sortable: false, width: "10px"},
                { text: this.$t('password'), value: 'password', align: 'center', sortable: false, width: "10px"},
                { text: this.$t('subjects'), value: 'subjects', align: 'center', sortable: false, width: "350px"},
            ]
        },
        createUserDialog: {
            get() { return this.getCreateUserDialog },
            set(value) { this.$store.commit('setCreateUserDialog', value) },
        },
        editPasswordDialog: {
            get() { return this.getEditPasswordDialog },
            set(value) { this.$store.commit('setEditPasswordDialog', value) },
        },
    },

    components: {
        CreateUser,
        EditPassword,
    },

    mixins: [toDatetime],
}
</script>
